// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"EditEntity-module__spinner--PZ","spin":"EditEntity-module__spin--DZ","tooltipWrapper":"EditEntity-module__tooltipWrapper--Ns"};